module.exports = __webpack_public_path__ + "img/AT.b26bd198.svg";